import React from 'react';

import '../style.css';
import LearnMoreButton from '../Buttons/LearnMore';
import ContactSupportButton from '../Buttons/ContactSupport';
import CONF from '../Conf';

export default function ErrorCard({ errors }) {
  const redirectLink = CONF.text['Support Link']();
  const fcolor = CONF.color('white');
  return (
    <article className='Error Card'>
      <header>
        <span>{CONF.text['Error Header']()}</span>
      </header>
      <section>
        <p>
          <span>{CONF.text['Error Section p1']()}</span>
        </p>
        <p>
          <span>{CONF.text['Error Section p2']()}</span>
        </p>
        <br></br>
        <ul type='disc'>
          <li>
            <span>{CONF.text['Error Bullets 1']()}</span>
          </li>
          <li>
            <span>{CONF.text['Error Bullets 2']()}</span>
          </li>
        </ul>
        <p>
          <span>{CONF.text['Error Section p3']()}</span>
        </p>
      </section>
      <footer>
        <br></br>
        <ContactSupportButton
          language={CONF.queryParam.language}
          redirectLinkOnClick={redirectLink}
          fillColor={fcolor}
        />
      </footer>
    </article>
  );
}
